import { Link } from "react-router-dom";
import { formatViews, type FeedItem } from "@/components/feature/ContentCard";

export default function NewsListItem({ item }: { item: FeedItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex gap-3 rounded-xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:gap-4 md:p-4"
    >
      <div className="h-20 w-28 shrink-0 overflow-hidden rounded-lg bg-background-200 md:h-24 md:w-40">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 我爱搞`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base line-clamp-2">
          {item.title}
        </h3>
        <p className="mt-1.5 hidden flex-1 text-sm text-foreground-500 line-clamp-2 sm:block">
          {item.excerpt}
        </p>
        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-400">
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-price-tag-3-line text-[13px]"></i>
            </span>
            {item.tags[0]}
          </span>
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-time-line text-[13px]"></i>
            </span>
            {item.publishedAt}
          </span>
          <span className="hidden items-center gap-1 whitespace-nowrap sm:inline-flex">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-eye-line text-[13px]"></i>
            </span>
            {formatViews(item.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}